<div class="scanafy-site" [class.mobile-nav-is-open]="mobileNavOpen">
    <header class="site-header">
        <nav class="nav-shell" aria-label="Main navigation">
            <a class="brand" [routerLink]="navPath(navItems[0])" aria-label="Scanafy home">
                <img
                        src="assets/scanafy-logo-44.webp"
                        srcset="assets/scanafy-logo-44.webp 1x, assets/scanafy-logo-88.webp 2x"
                        alt="Scanafy Logo"
                        width="44"
                        height="44"
                        loading="eager"
                        decoding="async"
                        fetchpriority="high"
                />
                <span>Scanafy</span>
            </a>

            <div id="primaryNavigation" class="nav-content scn-nav-panel" [class.open]="mobileNavOpen">
                <a
                        *ngFor="let item of navItems; trackBy: trackByIndex"
                        class="nav-link scn-nav-link"
                        [routerLink]="navPath(item)"
                        [class.active]="currentPage === item.page"
                >
                    {{ item.currentLabel }}
                </a>
                <a *ngIf="showDesktopFreeStartLink" class="nav-link scn-nav-link nav-free-start-link" [routerLink]="freeStartPath">
                    {{ 'SCN.CTA.START_FREE' | translate }}
                </a>

                <div class="nav-actions nav-panel-actions scn-nav-actions">
                    <button type="button" class="btn btn-ghost" (click)="openApp($event)">
                        {{ loginCta }}
                    </button>
                    <a class="btn btn-primary" [routerLink]="freeStartPath">{{ 'SCN.CTA.START_FREE' | translate }}</a>
                    <button type="button" class="btn btn-primary" (click)="openBookingDemoModal()">
                        {{ heroBookDemoCta }}
                    </button>
                </div>
            </div>

            <div class="nav-actions">
                <div class="mobile-header-actions">
                    <button type="button" class="language-button" (click)="changeLanguage(selectedLanguage === 'de' ? 'en' : 'de')">
                        {{ selectedLanguage === 'de' ? 'EN' : 'DE' }}
                    </button>

                    <button
                            type="button"
                            class="nav-toggle"
                            (click)="toggleMobileNav()"
                            [attr.aria-expanded]="mobileNavOpen"
                            [attr.aria-label]="mobileNavOpen ? 'Navigation schließen' : 'Navigation öffnen'"
                            aria-controls="primaryNavigation"
                    >
                        <span></span>
                        <span></span>
                        <span></span>
                    </button>
                </div>

                <button type="button" class="btn btn-ghost" (click)="openApp($event)">
                    {{ loginCta }}
                </button>
                <button type="button" class="btn btn-primary" (click)="openBookingDemoModal()">
                    {{ heroBookDemoCta }}
                </button>
            </div>
        </nav>
    </header>

    <main>
        <ng-container [ngSwitch]="currentPage">
            <ng-container *ngSwitchCase="'home'">
                <section class="hero-section section-pad scn-section scn-hero-section">
                    <div class="container-xl hero-grid scn-hero-grid">
                        <div class="hero-copy scn-hero-copy">
                            <div class="eyebrow">
                                <span class="eyebrow-dot"></span>
                                {{ heroEyebrow }}
                            </div>
                            <h1 class="scn-hero-title">{{ heroTitle }}</h1>
                            <p class="hero-lead">{{ heroSubtitle }}</p>

                            <div class="hero-actions scn-demo-actions">
                                <button type="button" class="btn btn-primary btn-large" (click)="openBookingDemoModal()">
                                    {{ heroBookDemoCta }}
                                </button>
                                <button type="button" class="btn btn-secondary btn-large" (click)="openDemoLandingPage($event)">
                                    {{ heroViewLiveDemoCta }}
                                </button>
                            </div>

                            <div class="proof-row scn-hero-stats" aria-label="Scanafy key facts">
                                <div *ngFor="let stat of proofStats; trackBy: trackByIndex" class="proof-item scn-hero-stat">
                                    <strong>{{ stat.value }}</strong>
                                    <span>{{ stat.currentLabel }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="hero-visual scn-hero-visual" aria-label="Scanafy product preview">
                            <div class="scn-phone-stage">
                                <div class="phone-frame scn-phone-frame">
                                    <div class="phone-notch"></div>
                                    <div class="phone-screen">
                                        <div class="phone-topbar">
                                            <img
                                                    src="assets/scanafy-logo-44.webp"
                                                    alt=""
                                                    width="44"
                                                    height="44"
                                                    loading="eager"
                                                    decoding="async"
                                                    fetchpriority="high"
                                            />
                                            <span>{{ 'SCN.HERO.PHONE_OBJECT' | translate }}</span>
                                        </div>
                                        <div class="emergency-card">
                                            <span class="status-pill">{{ 'SCN.HERO.PHONE_STATUS' | translate }}</span>
                                            <p class="emergency-card-title">{{ 'SCN.HERO.PHONE_TITLE' | translate }}</p>
                                            <p>{{ 'SCN.HERO.PHONE_TEXT' | translate }}</p>
                                        </div>
                                        <div class="contact-list">
                                            <div><i class="bi bi-droplet-half"></i><span>{{ 'SCN.HERO.PHONE_CONTACT_1' | translate }}</span></div>
                                            <div><i class="bi bi-lightning-charge"></i><span>{{ 'SCN.HERO.PHONE_CONTACT_2' | translate }}</span></div>
                                            <div><i class="bi bi-house-check"></i><span>{{ 'SCN.HERO.PHONE_CONTACT_3' | translate }}</span></div>
                                        </div>
                                    </div>
                                </div>

                                <div class="update-card floating-card scn-update-floating-card">
                                    <i class="bi bi-check2-circle"></i>
                                    <div>
                                        <strong>{{ 'SCN.HERO.UPDATE_TITLE' | translate }}</strong>
                                        <span>{{ 'SCN.HERO.UPDATE_TEXT' | translate }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section class="trust-strip scn-section">
                    <div class="container-xl trust-grid">
                        <p>{{ 'SCN.TRUST.INTRO' | translate }}</p>
                        <div class="trust-logo-preview">
                            <img
                                    *ngFor="let logo of featuredLogos; trackBy: trackByIndex"
                                    [src]="logo.src"
                                    [attr.srcset]="logo.srcset || null"
                                    [alt]="logo.altKey | translate"
                                    [attr.width]="logo.width"
                                    [attr.height]="logo.height"
                                    loading="lazy"
                                    decoding="async"
                            />
                        </div>
                    </div>
                </section>

                <section class="section-pad bg-soft scn-section">
                    <div class="container-xl split-layout scn-pain-layout">
                        <div>
                            <span class="section-kicker">{{ 'SCN.PAIN.KICKER' | translate }}</span>
                            <h2>{{ 'SCN.PAIN.TITLE' | translate }}</h2>
                            <p class="section-lead">{{ 'SCN.PAIN.SUBTITLE' | translate }}</p>
                        </div>
                        <div class="cards-grid three scn-pain-grid">
                            <article *ngFor="let item of painPoints; trackBy: trackByIndex" class="info-card scn-pain-card">
                                <i class="bi" [ngClass]="item.icon"></i>
                                <h3>{{ item.title | translate }}</h3>
                                <p>{{ item.text | translate }}</p>
                            </article>
                        </div>
                    </div>
                </section>

                <section class="section-pad scn-section scn-before-after-section" id="before-after">
                    <div class="container-xl">
                        <div class="centered-heading scn-section-heading">
                            <span class="section-kicker">{{ 'COMPANY_LANDING_PAGE.BEFORE_AFTER_KICKER' | translate }}</span>
                            <h2>{{ 'COMPANY_LANDING_PAGE.BEFORE_AFTER_TITLE' | translate }}</h2>
                            <p>{{ 'COMPANY_LANDING_PAGE.BEFORE_AFTER_SUBTITLE' | translate }}</p>
                        </div>

                        <div class="before-after-wrapper" aria-label="Before and after comparison of emergency information">
                            <div class="before-after-container">
                                <img
                                        src="assets/emergency-before-690.avif"
                                        srcset="
                                                assets/emergency-before-480.avif 480w,
                                                assets/emergency-before-690.avif 690w,
                                                assets/emergency-before-768.avif 768w,
                                                assets/emergency-before-1115.avif 1115w
                                              "
                                        sizes="(max-width: 768px) 100vw, 690px"
                                        [alt]="'COMPANY_LANDING_PAGE.BEFORE_AFTER_BEFORE_ALT' | translate"
                                        class="before-after-img"
                                        decoding="async"
                                        loading="lazy"
                                />

                                <div class="after-img-wrapper" [style.clipPath]="'inset(0 0 0 ' + beforeAfterValue + '%)'">
                                    <img
                                            src="assets/emergency-after-690.avif"
                                            srcset="
                                                    assets/emergency-after-480.avif 480w,
                                                    assets/emergency-after-690.avif 690w,
                                                    assets/emergency-after-768.avif 768w,
                                                    assets/emergency-after-1115.avif 1115w
                                                  "
                                            sizes="(max-width: 768px) 100vw, 690px"
                                            [alt]="'COMPANY_LANDING_PAGE.BEFORE_AFTER_AFTER_ALT' | translate"
                                            class="before-after-img"
                                            decoding="async"
                                            loading="lazy"
                                    />
                                </div>

                                <div class="before-after-handle" [style.left.%]="beforeAfterValue">
                                    <div class="handle-line"></div>
                                    <div class="handle-knob" aria-hidden="true">
                                        <i class="bi bi-chevron-left"></i>
                                        <i class="bi bi-chevron-right"></i>
                                    </div>
                                </div>

                                <input
                                        type="range"
                                        class="before-after-range"
                                        min="0"
                                        max="100"
                                        [(ngModel)]="beforeAfterValue"
                                        name="beforeAfterValue"
                                        aria-label="Slide to reveal before and after"
                                />

                                <div class="before-after-label before-label">
                                    {{ 'COMPANY_LANDING_PAGE.BEFORE_LABEL' | translate }}
                                </div>
                                <div class="before-after-label after-label">
                                    {{ 'COMPANY_LANDING_PAGE.AFTER_LABEL' | translate }}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section class="section-pad">
                    <div class="container-xl centered-heading">
                        <span class="section-kicker">{{ 'SCN.STEPS.KICKER' | translate }}</span>
                        <h2>{{ 'SCN.STEPS.TITLE' | translate }}</h2>
                        <p>{{ 'SCN.STEPS.SUBTITLE' | translate }}</p>
                    </div>
                    <div class="container-xl step-grid">
                        <article *ngFor="let step of steps; let i = index; trackBy: trackByIndex" class="step-card">
                            <span class="step-number" aria-hidden="true">0{{ i + 1 }}</span>
                            <i class="bi" [ngClass]="step.icon"></i>
                            <h3>{{ step.title | translate }}</h3>
                            <p>{{ step.text | translate }}</p>
                        </article>
                    </div>
                </section>

                <section class="section-pad bg-navy cta-band">
                    <div class="container-xl cta-grid">
                        <div>
                            <span class="section-kicker light">{{ 'SCN.HOME_CTA.KICKER' | translate }}</span>
                            <h2>{{ 'SCN.HOME_CTA.TITLE' | translate }}</h2>
                            <p>{{ 'SCN.HOME_CTA.TEXT' | translate }}</p>
                        </div>
                        <div class="cta-actions">
                            <button type="button" class="btn btn-light" (click)="openBookingDemoModal()">{{ 'SCN.CTA.BOOK_DEMO' | translate }}</button>
                            <button type="button" class="btn btn-outline-light" (click)="navigateTop(navPath(navItems[2]), $event)">{{ 'SCN.CTA.SEE_PRICING' | translate }}</button>
                        </div>
                    </div>
                </section>
            </ng-container>

            <ng-container *ngSwitchCase="'product'">
                <section class="page-hero section-pad compact">
                    <div class="container-xl centered-heading">
                        <span class="section-kicker">{{ 'SCN.PRODUCT.KICKER' | translate }}</span>
                        <h1>{{ 'SCN.PRODUCT.TITLE' | translate }}</h1>
                        <p>{{ 'SCN.PRODUCT.SUBTITLE' | translate }}</p>
                    </div>
                </section>

                <section *ngIf="productVideoConfigured" class="section-pad scn-product-video-section">
                    <div class="container-xl">
                        <div class="centered-heading scn-product-video-heading">
                            <span class="section-kicker">{{ 'SCN.PRODUCT_VIDEO.KICKER' | translate }}</span>
                            <h2>{{ 'SCN.PRODUCT_VIDEO.TITLE' | translate }}</h2>
                            <p>{{ 'SCN.PRODUCT_VIDEO.TEXT' | translate }}</p>
                        </div>

                        <div class="scn-product-video-card">
                            <button
                                    *ngIf="!productVideoStarted"
                                    type="button"
                                    class="scn-product-video-poster"
                                    (click)="startProductVideo()"
                                    [attr.aria-label]="'SCN.PRODUCT_VIDEO.PLAY_LABEL' | translate"
                            >
                                <img
                                        [src]="productVideoPosterUrl"
                                        [alt]="'SCN.PRODUCT_VIDEO.POSTER_ALT' | translate"
                                        width="2000"
                                        height="1125"
                                        loading="lazy"
                                        decoding="async"
                                />
                                <span class="scn-product-video-play" aria-hidden="true"><i class="bi bi-play-fill"></i></span>
                            </button>

                            <iframe
                                    *ngIf="productVideoStarted && productVideoUrl"
                                    [src]="productVideoUrl"
                                    [attr.title]="'SCN.PRODUCT_VIDEO.IFRAME_TITLE' | translate"
                                    allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
                                    allowfullscreen
                                    referrerpolicy="strict-origin-when-cross-origin"
                            ></iframe>
                        </div>

                        <div class="scn-product-video-actions">
                            <button type="button" class="btn btn-secondary" (click)="openDemoLandingPage($event)">
                                <i class="bi bi-box-arrow-up-right"></i>
                                {{ 'SCN.PRODUCT_VIDEO.INTERACTIVE_DEMO_CTA' | translate }}
                            </button>
                        </div>
                    </div>
                </section>

                <section class="section-pad">
                    <div class="container-xl cards-grid three">
                        <article *ngFor="let feature of featureCards; trackBy: trackByIndex" class="info-card tall scn-feature-card">
                            <i class="bi" [ngClass]="feature.icon"></i>
                            <h3>{{ feature.title | translate }}</h3>
                            <p>{{ feature.text | translate }}</p>
                        </article>
                    </div>
                </section>

                <section class="section-pad bg-soft demo-section">
                    <div class="container-xl split-layout align-center scn-demo-content">
                        <div class="scn-demo-copy">
                            <span class="section-kicker">{{ 'SCN.DEMO.KICKER' | translate }}</span>
                            <h2>{{ 'SCN.DEMO.TITLE' | translate }}</h2>
                            <p class="section-lead">{{ 'SCN.DEMO.TEXT' | translate }}</p>
                            <div class="demo-actions scn-demo-actions">
                                <button class="btn btn-primary" type="button" (click)="simulateQRScan($event)">
                                    <i class="bi bi-qr-code-scan"></i>
                                    {{ 'SCN.CTA.SCAN_DEMO' | translate }}
                                </button>
                                <span class="scan-message" *ngIf="scanMessage">{{ 'SCN.DEMO.SCAN_MESSAGE' | translate }}</span>
                            </div>
                        </div>
                        <button class="qr-demo scn-demo-qr-wrap" type="button" (click)="simulateQRScan($event)" aria-label="Open Scanafy demo page">
                            <img src="assets/landing-page-qr-code.avif" alt="QR Code to test Scanafy" loading="lazy" />
                            <span>{{ 'SCN.DEMO.QR_HINT' | translate }}</span>
                        </button>
                    </div>
                </section>

                <section class="section-pad">
                    <div class="container-xl centered-heading">
                        <span class="section-kicker">{{ 'ANALYTICS_OVERVIEW' | translate }}</span>
                        <h2>{{ 'ANALYTICS_OVERVIEW' | translate }}</h2>
                        <p>{{ 'ANALYTICS_OVERVIEW_DESCRIPTION' | translate }}</p>
                    </div>
                    <div class="container-xl analytics-showcase scn-analytics-grid">
                        <div class="analytics-overview-card scn-analytics-dashboard">
                            <div class="analytics-overview-head">
                                <div>
                                    <span class="mini-label">{{ 'ANALYTICS_OVERVIEW' | translate }}</span>
                                    <strong>{{ 'SCAN_TRENDS' | translate }}</strong>
                                </div>
                                <span class="analytics-live-pill">24/7</span>
                            </div>
                            <div class="analytics-chart scn-chart-bars">
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                            <div class="analytics-mini-stats">
                                <div>
                                    <strong>1,284</strong>
                                    <span>{{ 'SCAN_TRENDS' | translate }}</span>
                                </div>
                                <div>
                                    <strong>68%</strong>
                                    <span>{{ 'CONTENT_INTERACTIONS' | translate }}</span>
                                </div>
                                <div>
                                    <strong>24</strong>
                                    <span>{{ 'HEATMAPS' | translate }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="analytics-cards-grid scn-analytics-cards">
                            <article *ngFor="let item of analyticsCards; trackBy: trackByIndex" class="analytics-card scn-analytics-card">
                                <div class="analytics-card-head">
                                    <i class="bi" [ngClass]="item.icon"></i>
                                    <span>{{ item.metric }}</span>
                                </div>
                                <h3>{{ item.title | translate }}</h3>
                                <p>{{ item.text | translate }}</p>
                            </article>
                        </div>
                    </div>
                </section>

                <section class="section-pad bg-soft">
                    <div class="container-xl centered-heading">
                        <span class="section-kicker">{{ 'USE_CASES_TITLE' | translate }}</span>
                        <h2>{{ 'USE_CASES_TITLE' | translate }}</h2>
                        <p>{{ 'USE_CASES_DESCRIPTION' | translate }}</p>
                    </div>
                    <div class="container-xl use-cases-grid">
                        <article *ngFor="let item of useCaseMediaCards; trackBy: trackByIndex" class="use-case-media-card">
                            <img [src]="item.image" [alt]="(item.title | translate)" loading="lazy" />
                            <div class="use-case-media-body">
                                <span class="mini-label">{{ 'USE_CASES_TITLE' | translate }}</span>
                                <h3>{{ item.title | translate }}</h3>
                                <p>{{ item.text | translate }}</p>
                                <div class="use-case-actions">
                                    <button *ngIf="item.action === 'poster'" type="button" class="btn btn-secondary" (click)="openUseCasePosterPdf($event)">
                                        PDF
                                    </button>
                                    <button *ngIf="item.action === 'demo'" type="button" class="btn btn-primary" (click)="openUseCaseDemoLandingPage($event)">
                                        {{ 'USE_CASES_CTA_BUTTON' | translate }}
                                    </button>
                                </div>
                            </div>
                        </article>
                        <article *ngFor="let item of useCaseCards; trackBy: trackByIndex" class="use-case-card">
                            <i class="bi" [ngClass]="item.icon"></i>
                            <h3>{{ item.title | translate }}</h3>
                            <p>{{ item.text | translate }}</p>
                        </article>
                    </div>
                    <div class="container-xl use-case-footer-cta scn-use-cases-cta">
                        <p>{{ 'USE_CASES_CTA_HINT' | translate }}</p>
                        <button type="button" class="btn btn-primary" (click)="openUseCaseDemoLandingPage($event)">
                            {{ 'USE_CASES_CTA_BUTTON' | translate }}
                        </button>
                    </div>
                </section>
            </ng-container>

            <ng-container *ngSwitchCase="'pricing'">
                <section class="page-hero section-pad compact">
                    <div class="container-xl centered-heading">
                        <span class="section-kicker">{{ 'SCN.PRICING.KICKER' | translate }}</span>
                        <h1>{{ 'SCN.PRICING.TITLE' | translate }}</h1>
                        <p>{{ 'SCN.PRICING.SUBTITLE' | translate }}</p>
                    </div>
                </section>

                <section class="section-pad pricing-section">
                    <div class="container-xl pricing-grid scn-pricing-grid">
                        <article class="pricing-card scn-pricing-card">
                            <div class="scn-pricing-card-body">
                                <div class="scn-pricing-card-top">
                                    <h2>{{ 'SCN.PRICING.FREE_TITLE' | translate }}</h2>
                                    <div class="plan-price">0 €</div>
                                    <p class="plan-note">/ {{ 'FOREVER' | translate }}</p>
                                </div>
                                <ul class="scn-pricing-features">
                                    <li><i class="bi bi-check2"></i>{{ 'pricing.free.feature1' | translate }}</li>
                                    <li><i class="bi bi-check2"></i>{{ 'pricing.free.feature3' | translate }}</li>
                                    <li><i class="bi bi-check2"></i>{{ 'pricing.free.feature4' | translate }}</li>
                                    <li><i class="bi bi-check2"></i>{{ 'pricing.free.feature8' | translate }}</li>
                                    <li><i class="bi bi-check2"></i>{{ 'pricing.free.feature9' | translate }}</li>
                                    <li><i class="bi bi-check2"></i>{{ 'pricing.free.feature10' | translate }}</li>
                                </ul>
                                <details class="pricing-more">
                                    <summary>{{ 'pricing.common.moreFeatures' | translate }}</summary>
                                    <ul class="list-unstyled">
                                        <li><i class="bi bi-plus-circle"></i>{{ 'pricing.free.feature2' | translate }}</li>
                                        <li><i class="bi bi-plus-circle"></i>{{ 'pricing.free.feature5' | translate }}</li>
                                        <li><i class="bi bi-plus-circle"></i>{{ 'pricing.free.feature6' | translate }}</li>
                                        <li><i class="bi bi-plus-circle"></i>{{ 'pricing.free.feature7' | translate }}</li>
                                    </ul>
                                </details>
                                <div class="pricing-card-actions scn-pricing-actions">
                                    <button type="button" class="btn btn-secondary" (click)="openRegistration($event)">
                                        {{ 'SCN.CTA.START_FREE' | translate }}
                                    </button>
                                </div>
                            </div>
                        </article>

                        <article class="pricing-card featured scn-pricing-card is-featured">
                            <div class="scn-pricing-card-body">
                                <div class="scn-pricing-card-top">
                                    <div class="plan-badge">★ {{ 'BEST_VALUE' | translate }}</div>
                                    <h2>{{ 'SCN.PRICING.PRO_TITLE' | translate }}</h2>
                                    <div class="plan-price">99 €</div>
                                    <p class="plan-note">{{ 'PER_INTERVAL_10_PROPERTIES' | translate:{ interval: ('INTERVAL_YEAR' | translate) } }}</p>
                                </div>
                                <ul class="scn-pricing-features">
                                    <li><i class="bi bi-check2"></i>{{ 'pricing.pro.feature1' | translate }}</li>
                                    <li><i class="bi bi-check2"></i>{{ 'pricing.pro.feature2' | translate }}</li>
                                    <li><i class="bi bi-check2"></i>{{ 'pricing.pro.feature3' | translate }}</li>
                                    <li><i class="bi bi-check2"></i>{{ 'pricing.pro.feature4' | translate }}</li>
                                    <li><i class="bi bi-check2"></i>{{ 'pricing.pro.feature8' | translate }}</li>
                                    <li><i class="bi bi-check2"></i>{{ 'pricing.pro.feature7' | translate }}</li>
                                    <li><i class="bi bi-check2"></i>{{ 'pricing.pro.feature5' | translate }}</li>
                                    <li><i class="bi bi-check2"></i>{{ 'pricing.pro.feature6' | translate }}</li>
                                </ul>
                                <details class="pricing-more">
                                    <summary>{{ 'pricing.common.moreFeatures' | translate }}</summary>
                                    <ul class="list-unstyled">
                                        <li><i class="bi bi-plus-circle"></i>{{ 'pricing.basic.feature5' | translate }}</li>
                                    </ul>
                                </details>
                                <div class="pricing-card-actions scn-pricing-actions">
                                    <button type="button" class="btn btn-primary" (click)="openBookingDemoModal()">
                                        {{ 'SCN.CTA.BOOK_DEMO' | translate }}
                                    </button>
                                </div>
                            </div>
                        </article>

                        <article class="pricing-card scn-pricing-card">
                            <div class="scn-pricing-card-body">
                                <div class="scn-pricing-card-top">
                                    <h2>{{ 'SCN.PRICING.BUSINESS_TITLE' | translate }}</h2>
                                    <div class="plan-price">{{ 'CUSTOM_PRICING' | translate }}</div>
                                    <p class="plan-note">{{ 'CONTACT_FOR_CUSTOM_QUOTE' | translate }}</p>
                                </div>
                                <ul class="scn-pricing-features">
                                    <li><i class="bi bi-check2"></i>{{ 'pricing.business.feature1' | translate }}</li>
                                    <li><i class="bi bi-check2"></i>{{ 'pricing.business.feature2' | translate }}</li>
                                    <li><i class="bi bi-check2"></i>{{ 'pricing.business.feature3' | translate }}</li>
                                    <li><i class="bi bi-check2"></i>{{ 'pricing.business.feature9' | translate }}</li>
                                    <li><i class="bi bi-check2"></i>{{ 'pricing.business.feature4' | translate }}</li>
                                    <li><i class="bi bi-check2"></i>{{ 'pricing.business.feature5' | translate }}</li>
                                    <li><i class="bi bi-check2"></i>{{ 'pricing.business.feature7' | translate }}</li>
                                </ul>
                                <details class="pricing-more">
                                    <summary>{{ 'pricing.common.moreFeatures' | translate }}</summary>
                                    <ul class="list-unstyled">
                                        <li><i class="bi bi-plus-circle"></i>{{ 'pricing.business.feature6' | translate }}</li>
                                        <li><i class="bi bi-plus-circle"></i>{{ 'pricing.business.feature8' | translate }}</li>
                                    </ul>
                                </details>
                                <div class="pricing-card-actions scn-pricing-actions">
                                    <button type="button" class="btn btn-secondary" (click)="openBookingDemoModal()">
                                        {{ 'SCN.CTA.BOOK_DEMO' | translate }}
                                    </button>
                                </div>
                            </div>
                        </article>
                    </div>
                    <div class="container-xl pricing-note-row">
                        <p>{{ 'SCN.PRICING.MATERIAL_NOTE' | translate }}</p>
                    </div>
                </section>

                <section class="section-pad bg-soft scn-pricing-calculator-section" id="calculator">
                    <div class="container-xl">
                        <div class="scn-calculator-card">
                            <header class="scn-calculator-header">
                                <span class="section-kicker">{{ 'PRICING_CALCULATOR_TITLE' | translate }}</span>
                                <h2>{{ 'PRICING_CALCULATOR_TITLE' | translate }}</h2>
                                <p>{{ 'PRICING_CALCULATOR_SUBTITLE' | translate }}</p>
                            </header>

                            <div class="scn-calculator-body">
                                <div class="scn-calculator-controls">
                                    <label class="scn-range-label" for="property-count">
                                        <span>{{ 'NUMBER_PROPERTIES' | translate }}</span>
                                        <strong>{{ normalizedPropertyCount }}</strong>
                                    </label>
                                    <input
                                            id="property-count"
                                            type="range"
                                            min="1"
                                            max="500"
                                            [ngModel]="propertyCount"
                                            (ngModelChange)="updatePropertyCount($event)"
                                    />
                                    <div class="scn-calculator-toolbar">
                                        <span class="scn-plan-badge">{{ selectedPlanLabel | translate }}</span>
                                        <button type="button" class="btn btn-secondary btn-small" (click)="resetCalculator()">
                                            {{ 'RESET_BUTTON' | translate }}
                                        </button>
                                    </div>
                                    <p *ngIf="upgradeAdvice" class="scn-business-hint">{{ upgradeAdvice }}</p>
                                </div>

                                <div class="scn-calculator-summary">
                                    <div class="scn-total-card">
                                        <span>{{ 'ESTIMATED_TOTAL' | translate }}</span>
                                        <strong>{{ totalPrice === 0 ? formatPriceShort(0) : formatPrice(totalPrice) }}</strong>
                                    </div>
                                    <div class="scn-roi-metrics">
                                        <div class="scn-roi-metric">
                                            <strong>{{ dynamicROI.hoursSaved }}</strong>
                                            <span>{{ 'ROI_TIME_SAVED' | translate }}</span>
                                        </div>
                                        <div class="scn-roi-metric">
                                            <strong>{{ dynamicROI.complaintReductionPercent }}%</strong>
                                            <span>{{ 'ROI_COMPLAINT_REDUCTION_LABEL' | translate }}</span>
                                        </div>
                                        <div class="scn-roi-metric">
                                            <strong>{{ formatPrice(dynamicROI.reprintSavings) }}</strong>
                                            <span>{{ 'ROI_NO_REPRINTS' | translate }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <aside class="scn-calculator-explain">
                                <h3>{{ 'ROI_HEADLINE' | translate }}</h3>
                                <p>{{ 'ROI_HINTS' | translate }}</p>
                                <ul class="scn-roi-explain-list">
                                    <li>
                                        <i class="bi bi-clock" aria-hidden="true"></i>
                                        <span>{{ 'ROI_HOURS_HINT_PREFIX' | translate }}30{{ 'ROI_HOURS_HINT_SUFFIX' | translate }}</span>
                                    </li>
                                    <li>
                                        <i class="bi bi-receipt" aria-hidden="true"></i>
                                        <span>{{ 'ROI_REPRINT_HINT_PREFIX' | translate }}3 €{{ 'ROI_REPRINT_HINT_MID' | translate }}20 €{{ 'ROI_REPRINT_HINT_SUFFIX' | translate }}</span>
                                    </li>
                                    <li>
                                        <i class="bi bi-info-circle" aria-hidden="true"></i>
                                        <span>{{ 'NET_PRICES_NOTICE' | translate }}</span>
                                    </li>
                                    <li>
                                        <i class="bi bi-palette" aria-hidden="true"></i>
                                        <span>{{ 'WHITE_LABELING_NOTE' | translate }}</span>
                                    </li>
                                </ul>
                            </aside>
                        </div>
                    </div>
                </section>
            </ng-container>

            <ng-container *ngSwitchCase="'customers'">
                <section class="page-hero section-pad compact">
                    <div class="container-xl centered-heading">
                        <span class="section-kicker">{{ 'SCN.CUSTOMERS.KICKER' | translate }}</span>
                        <h1>{{ 'SCN.CUSTOMERS.TITLE' | translate }}</h1>
                        <p>{{ 'SCN.CUSTOMERS.SUBTITLE' | translate }}</p>
                    </div>
                </section>

                <section class="section-pad">
                    <div class="container-xl logo-wall">
                        <div *ngFor="let logo of logos; trackBy: trackByIndex" class="logo-tile">
                            <img
                                    [src]="logo.src"
                                    [attr.srcset]="logo.srcset || null"
                                    [alt]="logo.altKey | translate"
                                    [attr.width]="logo.width"
                                    [attr.height]="logo.height"
                                    loading="lazy"
                                    decoding="async"
                            />
                        </div>
                    </div>
                </section>

                <section class="section-pad bg-soft">
                    <div class="container-xl testimonial-grid">
                        <article *ngFor="let item of testimonials; trackBy: trackByIndex" class="testimonial-card">
                            <i class="bi bi-chat-quote"></i>
                            <blockquote>“{{ item.quote | translate }}”</blockquote>
                            <div>
                                <strong>{{ item.name }}</strong>
                                <span>{{ item.role | translate }} · {{ item.company }}</span>
                            </div>
                        </article>
                    </div>
                </section>
            </ng-container>

            <ng-container *ngSwitchCase="'resources'">
                <section class="page-hero section-pad compact">
                    <div class="container-xl centered-heading">
                        <span class="section-kicker">{{ 'SCN.RESOURCES.KICKER' | translate }}</span>
                        <h1>{{ 'SCN.RESOURCES.TITLE' | translate }}</h1>
                        <p>{{ 'SCN.RESOURCES.SUBTITLE' | translate }}</p>
                    </div>
                </section>

                <section class="section-pad">
                    <div class="container-md faq-list">
                        <details *ngFor="let item of faqItems; trackBy: trackByIndex">
                            <summary>{{ item.question | translate }}</summary>
                            <p>{{ item.answer | translate }}</p>
                        </details>
                    </div>
                </section>

                <section class="section-pad bg-soft">
                    <div class="container-xl resource-cards">
                        <a class="resource-card" href="/docs" target="_blank" rel="noopener noreferrer">
                            <i class="bi bi-journal-text"></i>
                            <h3>{{ 'SCN.RESOURCES.DOCS_TITLE' | translate }}</h3>
                            <p>{{ 'SCN.RESOURCES.DOCS_TEXT' | translate }}</p>
                        </a>
                        <button class="resource-card" type="button" (click)="openBookingDemoModal()">
                            <i class="bi bi-calendar-check"></i>
                            <h3>{{ 'SCN.RESOURCES.DEMO_TITLE' | translate }}</h3>
                            <p>{{ 'SCN.RESOURCES.DEMO_TEXT' | translate }}</p>
                        </button>
                    </div>
                </section>
            </ng-container>

            <ng-container *ngSwitchCase="'contact'">
                <section class="page-hero section-pad compact">
                    <div class="container-xl centered-heading">
                        <span class="section-kicker">{{ 'SCN.CONTACT.KICKER' | translate }}</span>
                        <h1>{{ 'SCN.CONTACT.TITLE' | translate }}</h1>
                        <p>{{ 'SCN.CONTACT.SUBTITLE' | translate }}</p>
                    </div>
                </section>

                <section class="section-pad contact-section">
                    <div class="container-xl contact-grid">
                        <div class="contact-panel">
                            <h2>{{ 'SCN.CONTACT.BOOK_TITLE' | translate }}</h2>
                            <p class="contact-book-text">{{ 'SCN.CONTACT.BOOK_TEXT' | translate }}</p>

                            <button
                                    type="button"
                                    class="btn btn-primary contact-book-button"
                                    (click)="openBookingDemoModal()"
                            >
                                <i class="bi bi-calendar-check"></i>
                                {{ 'SCN.CTA.BOOK_DEMO' | translate }}
                            </button>

                            <div class="contact-details">
                                <a href="mailto:contact@scanafy.de"><i class="bi bi-envelope"></i> contact&#64;scanafy.de</a>
                                <a href="tel:+4915125019782"><i class="bi bi-telephone"></i> 0151 25019782</a>
<!--                                <span><i class="bi bi-geo-alt"></i> Hamburger Straße 2a, 22949 Ammersbek</span>-->
                            </div>
                        </div>

                        <form class="contact-form" [formGroup]="contactForm" (ngSubmit)="onSubmit()" novalidate>
                            <div class="d-none" aria-hidden="true">
                                <label for="website">Website</label>
                                <input id="website" type="text" formControlName="website" tabindex="-1" autocomplete="off" />
                            </div>

                            <div class="scn-form-field">
                                <label for="contact-company">{{ 'SCN.FORM.COMPANY' | translate }}</label>
                                <input
                                        id="contact-company"
                                        type="text"
                                        formControlName="company"
                                        autocomplete="organization"
                                        [class.is-invalid]="isInvalid('company')"
                                        [attr.aria-invalid]="isInvalid('company')"
                                        [attr.aria-describedby]="isInvalid('company') ? 'company-error' : null"
                                />
                                <div
                                        *ngIf="isInvalid('company')"
                                        class="scn-field-error"
                                        id="company-error"
                                        role="alert"
                                >
                                    <i class="bi bi-exclamation-circle" aria-hidden="true"></i>
                                    <span>{{ getErrorMessage('company') }}</span>
                                </div>
                            </div>

                            <div class="scn-form-field">
                                <label for="contact-name">{{ 'SCN.FORM.NAME' | translate }}</label>
                                <input
                                        id="contact-name"
                                        type="text"
                                        formControlName="name"
                                        autocomplete="name"
                                        [class.is-invalid]="isInvalid('name')"
                                        [attr.aria-invalid]="isInvalid('name')"
                                        [attr.aria-describedby]="isInvalid('name') ? 'name-error' : null"
                                />
                                <div
                                        *ngIf="isInvalid('name')"
                                        class="scn-field-error"
                                        id="name-error"
                                        role="alert"
                                >
                                    <i class="bi bi-exclamation-circle" aria-hidden="true"></i>
                                    <span>{{ getErrorMessage('name') }}</span>
                                </div>
                            </div>

                            <div class="scn-form-field">
                                <label for="contact-email">{{ 'SCN.FORM.EMAIL' | translate }}</label>
                                <input
                                        id="contact-email"
                                        type="email"
                                        formControlName="email"
                                        autocomplete="email"
                                        [class.is-invalid]="isInvalid('email')"
                                        [attr.aria-invalid]="isInvalid('email')"
                                        [attr.aria-describedby]="isInvalid('email') ? 'email-error' : null"
                                />
                                <div
                                        *ngIf="isInvalid('email')"
                                        class="scn-field-error"
                                        id="email-error"
                                        role="alert"
                                >
                                    <i class="bi bi-exclamation-circle" aria-hidden="true"></i>
                                    <span>{{ getErrorMessage('email') }}</span>
                                </div>
                            </div>

                            <div class="scn-form-field">
                                <label for="contact-phone">{{ 'SCN.FORM.PHONE' | translate }}</label>
                                <input
                                        id="contact-phone"
                                        type="tel"
                                        formControlName="phone"
                                        autocomplete="tel"
                                        [class.is-invalid]="isInvalid('phone')"
                                        [attr.aria-invalid]="isInvalid('phone')"
                                        [attr.aria-describedby]="isInvalid('phone') ? 'phone-error' : null"
                                />
                                <div
                                        *ngIf="isInvalid('phone')"
                                        class="scn-field-error"
                                        id="phone-error"
                                        role="alert"
                                >
                                    <i class="bi bi-exclamation-circle" aria-hidden="true"></i>
                                    <span>{{ getErrorMessage('phone') }}</span>
                                </div>
                            </div>

                            <div class="scn-form-field full">
                                <label for="contact-message">{{ 'SCN.FORM.MESSAGE' | translate }}</label>
                                <textarea
                                        id="contact-message"
                                        rows="5"
                                        formControlName="message"
                                        [class.is-invalid]="isInvalid('message')"
                                        [attr.aria-invalid]="isInvalid('message')"
                                        [attr.aria-describedby]="isInvalid('message') ? 'message-error' : null"
                                ></textarea>
                                <div
                                        *ngIf="isInvalid('message')"
                                        class="scn-field-error"
                                        id="message-error"
                                        role="alert"
                                >
                                    <i class="bi bi-exclamation-circle" aria-hidden="true"></i>
                                    <span>{{ getErrorMessage('message') }}</span>
                                </div>
                            </div>

                            <button type="submit" class="btn btn-primary full" [disabled]="isLoading">
                                {{ isLoading ? ('SCN.FORM.SENDING' | translate) : ('SCN.FORM.SUBMIT' | translate) }}
                            </button>
                        </form>
                    </div>
                </section>
            </ng-container>

            <ng-container *ngSwitchCase="'impressum'">
                <section class="page-hero section-pad compact">
                    <div class="container-xl centered-heading">
                        <span class="section-kicker">{{ 'SCN.LEGAL.KICKER' | translate }}</span>
                        <h1>{{ 'SCN.LEGAL.IMPRINT_TITLE' | translate }}</h1>
                    </div>
                </section>

                <section class="section-pad legal-section">
                    <article class="container-md legal-card">
                        <h2>{{ 'SCN.LEGAL.IMPRINT_TITLE' | translate }}</h2>
                        <p>Scanafy (Einzelunternehmer)<br />Sameh Ben Said<br />Hamburger Straße 2a<br />22949 Ammersbek<br />Deutschland</p>
                        <p>Kontakt:<br />Telefon: 0151 25019782<br />E-Mail: contact&#64;scanafy.de<br />USt-IdNr.: DE 453 196 825</p>
                        <p>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV:<br />Sameh Ben Said, Hamburger Straße 2a, 22949 Ammersbek</p>
                    </article>
                </section>
            </ng-container>

            <ng-container *ngSwitchCase="'datenschutz'">
                <section class="page-hero section-pad compact">
                    <div class="container-xl centered-heading">
                        <span class="section-kicker">{{ 'SCN.LEGAL.KICKER' | translate }}</span>
                        <h1>{{ 'SCN.LEGAL.PRIVACY_TITLE' | translate }}</h1>
                    </div>
                </section>

                <section class="section-pad legal-section">
                    <article class="container-md legal-card">
                        <h2>{{ 'SCN.LEGAL.PRIVACY_TITLE' | translate }}</h2>
                        <p>Wir nehmen den Schutz Ihrer Daten ernst. Nachfolgend informieren wir Sie über Art, Umfang und Zwecke der Verarbeitung personenbezogener Daten auf dieser Website und in unserer Web-Plattform „Scanafy“.</p>
                        <h3>1. Verantwortlicher</h3>
                        <p>Scanafy – Sameh Ben Said<br />Hamburger Straße 2a, 22949 Ammersbek, Deutschland<br />E-Mail: contact&#64;scanafy.de</p>
                        <h3>2. Verarbeitete Daten und Zwecke</h3>
                        <p>- Webseite/Server: technisch notwendige Protokolldaten (z. B. IP-Adresse, Zeitpunkt, angeforderte Ressource) zur Bereitstellung, Stabilität und Sicherheit der Website (Art. 6 Abs. 1 lit. f DSGVO).</p>
                        <p>- Kontaktformular: von Ihnen eingegebene Daten (Name, E-Mail, Telefonnummer, Nachricht) zur Bearbeitung Ihrer Anfrage (Art. 6 Abs. 1 lit. b oder lit. f DSGVO).</p>
                        <p>- Lead-Capture-Formular (Angebot/Produktinfos): von Ihnen eingegebene Daten (E-Mail, Unternehmen, optional Name, optional Objektanzahl) sowie technische Metadaten (Zeitpunkt/Trigger) zur Bearbeitung Ihrer Anfrage und Kontaktaufnahme (Art. 6 Abs. 1 lit. a DSGVO; Einwilligung jederzeit widerrufbar).</p>
                        <p>- Kundenkonto/Plattform: Unternehmens- und Objektangaben, Dokumente sowie QR-Code-Metadaten zur Vertragserfüllung und Leistungserbringung (Art. 6 Abs. 1 lit. b DSGVO).</p>
                        <p>
                            - Vertriebs- und Marketingkontakt: Sofern der Nutzer hierzu gesondert eingewilligt hat,
                            verwendet Scanafy die im Kundenkonto hinterlegte geschäftliche E-Mail-Adresse und
                            Telefonnummer, um den Nutzer telefonisch und per E-Mail über Scanafy-Produkte,
                            Dienstleistungen, Angebote und mögliche kostenpflichtige Tarife zu informieren und
                            zu Vertriebszwecken zu kontaktieren. Die Einwilligung ist freiwillig und kann jederzeit
                            mit Wirkung für die Zukunft widerrufen werden (Art. 6 Abs. 1 lit. a DSGVO).
                        </p>
                        <p>- Nutzungsstatistiken in Scanafy: aggregierte/anonymisierte Scan-Zahlen, Interaktionstypen (z. B. Dokumentansicht, Sprachwechsel, Kontakt-Klick) und Sprachverteilung. Es erfolgt keine personenbezogene Auswertung einzelner Besucher (kein Nutzer-Tracking). Zweck: Funktionsbereitstellung und Qualitätsverbesserung (Art. 6 Abs. 1 lit. f DSGVO).</p>
                        <p>- Cookies: Wir verwenden ausschließlich technisch notwendige Cookies. Optionale Analyse-/Marketing-Cookies werden nur eingesetzt, wenn Sie zuvor einwilligen (Art. 6 Abs. 1 lit. a DSGVO). Ihre Einwilligung können Sie jederzeit für die Zukunft widerrufen.</p>
                        <p>- Bestellung physischer QR-Schilder: Identität des Bestellers, Unternehmensdaten, Versand- und Rechnungskontaktdaten, Objektanschriften, ausgewählte Produkt- und Druckinformationen (Bohroption, Stückzahl, Druckdaten einschließlich hochgeladener Logos, Bilder, Texte und Branding-Inhalte), Bestelldaten, Zahlungsstatus, Versandstatus, rechtliche Annahmeaufzeichnungen (Annahmezeitpunkt, bestellende Person, zugeordnete Links zu den Rechtsdokumenten) sowie Aufzeichnungen zum Transaktions-E-Mail-Versand und betriebliche Audit-Protokolle. Zweck: Auftragsabwicklung, Produktion, Versand und Erfüllung rechtlicher Dokumentationspflichten (Art. 6 Abs. 1 lit. b und lit. c DSGVO).</p>
                        <h3>3. Empfänger/Kategorien von Empfängern</h3>
                        <p>Hosting- und Infrastruktur-Dienstleister (EU/EWR). Für die Abwicklung von Schilderbestellungen können personenbezogene Daten an Produktionsdienstleister (Druckerei), Versanddienstleister, E-Mail-Versanddienstleister (Transaktions-E-Mails) und Cloud-Speicherdienstleister (EU/EWR) weitergegeben werden. Eine Weitergabe an sonstige Dritte erfolgt nur, wenn dies zur Vertragserfüllung erforderlich oder gesetzlich vorgeschrieben ist.</p>
                        <h3>4. Speicherdauer</h3>
                        <p>- Server-Logdaten: in der Regel bis zu 14 Tagen.</p>
                        <p>- Anfragen über das Kontaktformular: bis zu 12 Monate nach Abschluss der Bearbeitung.</p>
                        <p>- Vertrags-/Kundendaten: für die Dauer des Vertragsverhältnisses und anschließend entsprechend gesetzlicher Aufbewahrungsfristen.</p>
                        <p>- Bestell- und Auftragsdaten (physische Schilder): für die Dauer der Auftragsabwicklung und anschließend entsprechend gesetzlicher Aufbewahrungsfristen (insbesondere handels- und steuerrechtliche Aufbewahrungspflichten). Aufzeichnungen der rechtlichen Annahme (Annahmezeitpunkt, bestellende Person, zugeordnete Rechtsdokument-Links) werden für die Dauer der gesetzlichen Aufbewahrungsfristen gespeichert.</p>
                        <h3>5. Ihre Rechte</h3>
                        <p>Sie haben Rechte auf Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung, Datenübertragbarkeit und Widerspruch. Zudem besteht ein Beschwerderecht bei einer Datenschutzaufsichtsbehörde. Bitte wenden Sie sich hierzu an contact&#64;scanafy.de.</p>
                        <h3>6. Datenportabilität (EU Data Act)</h3>
                        <p>Wir unterstützen Sie bei der Mitnahme Ihrer in Scanafy gespeicherten Daten und stellen exportierbare Daten in einem gängigen, maschinenlesbaren Format zur Verfügung, soweit gesetzlich vorgesehen.</p>
                    </article>
                </section>
            </ng-container>

            <ng-container *ngSwitchCase="'agb'">
                <section class="page-hero section-pad compact">
                    <div class="container-xl centered-heading">
                        <span class="section-kicker">{{ 'SCN.LEGAL.KICKER' | translate }}</span>
                        <h1>{{ 'SCN.LEGAL.TERMS_TITLE' | translate }}</h1>
                    </div>
                </section>

                <section class="section-pad legal-section">
                    <article class="container-md legal-card">
                        <h2>{{ 'SCN.LEGAL.TERMS_TITLE' | translate }}</h2>
                        <h3>1. Geltungsbereich</h3>
                        <p>Diese AGB regeln die Nutzung der Web-Plattform „Scanafy“ zwischen Scanafy (Sameh Ben Said) und gewerblichen Kunden. Für Bestellungen physischer QR-Schilder gelten ergänzend die <a [href]="getLegalRoute('signOrderTerms')" (click)="navigateTop(getLegalRoute('signOrderTerms'), $event)">Bedingungen für physische QR-Schilderbestellungen</a>. Soweit diese für die jeweilige Bestellung speziellere Regelungen enthalten, gehen sie den allgemeinen Geschäftsbedingungen vor.</p>
                        <h3>2. Vertragsgegenstand</h3>
                        <p>Scanafy stellt eine Software-as-a-Service-Lösung für das digitale Immobilien-Informationsmanagement bereit (u. a. Verwaltung von Objekten, QR-Codes, mehrsprachige Landingpages, Dokumentenupload sowie Heatmaps/Scan-Statistiken). Es handelt sich nicht um einen Werkvertrag; eine Abnahme ist nicht erforderlich.</p>
                        <h3>3. Vertragslaufzeit und Kündigung</h3>
                        <p>Verträge werden grundsätzlich mit einer Laufzeit von 12 Monaten geschlossen und verlängern sich automatisch um weitere 12 Monate, sofern nicht mit einer Frist von 3 Monaten zum Laufzeitende in Textform (z. B. E-Mail) gemäß § 126b BGB gekündigt wird. Das Recht zur außerordentlichen Kündigung aus wichtigem Grund bleibt unberührt.</p>
                        <h3>4. Vergütung und Zahlung</h3>
                        <p>Die Vergütung richtet sich nach dem gewählten Tarif/Angebot. Die Zahlung erfolgt jährlich im Voraus binnen 14 Tagen ab Rechnungsdatum per SEPA-Überweisung; alle Preise verstehen sich zzgl. gesetzlicher Umsatzsteuer. Preisänderungen werden mindestens 6 Wochen vor Vertragsjahresende angekündigt; bei Steigerungen über 10 % besteht ein Sonderkündigungsrecht zum Periodenende.</p>
                        <h3>5. Verfügbarkeit, Wartung und Support</h3>
                        <p>Angestrebte Verfügbarkeit: 99,0 % im Jahresmittel (unverbindlicher Zielwert; kein SLA). Geplante Wartungen werden mindestens 24 Stunden vorher angekündigt, vorzugsweise zwischen 22:00 und 06:00 Uhr. Support: Mo-Fr (Feiertage Hamburg ausgenommen) 09:00-17:00 Uhr per E-Mail; Reaktionszeit nach Best-Effort.</p>
                        <h3>6. Nutzungsrechte</h3>
                        <p>Der Kunde erhält ein einfaches, nicht übertragbares, auf die Vertragsdauer beschränktes Nutzungsrecht. Untersagt sind u. a. Reverse Engineering, Weiterlizenzierung und automatisiertes Massen-Scraping. Bei Missbrauch kann der Zugang nach Ankündigung vorübergehend gesperrt werden.</p>
                        <h3>7. Datenschutz</h3>
                        <p>Informationen zur Verarbeitung personenbezogener Daten finden Sie in der Datenschutzerklärung. Scanafy unterstützt die Datenportabilität gemäß EU Data Act durch Bereitstellung exportierbarer Daten.</p>
                        <h3>8. Haftung</h3>
                        <p>Scanafy haftet unbeschränkt bei Vorsatz, grober Fahrlässigkeit, Verletzung von Leben, Körper oder Gesundheit sowie nach dem Produkthaftungsgesetz. Bei einfacher Fahrlässigkeit nur bei Verletzung wesentlicher Vertragspflichten (Kardinalpflichten) und beschränkt auf den vertragstypischen, vorhersehbaren Schaden, höchstens auf die im jeweiligen Vertragsjahr gezahlte Vergütung. Eine Haftung für mittelbare Schäden/entgangenen Gewinn ist ausgeschlossen.</p>
                        <h3>9. Referenzen und Vertraulichkeit</h3>
                        <p>
                            Mit der Erstellung eines kostenlosen Scanafy-Kontos erklärt sich der Kunde damit einverstanden,
                            dass Scanafy den Unternehmensnamen und das Unternehmenslogo zu Referenz- und Marketingzwecken
                            auf der Scanafy-Website sowie in eigenen Marketingmedien verwenden darf.
                            Der Kunde kann dieser Nutzung jederzeit mit Wirkung für die Zukunft widersprechen.
                            Vertrags- und Geschäftsgeheimnisse behandeln beide Parteien vertraulich.
                        </p>
                        <h3>10. Schlussbestimmungen</h3>
                        <p>Es gilt deutsches Recht; Gerichtsstand ist Hamburg. Änderungen/Ergänzungen bedürfen der Textform (E-Mail ausreichend). Sollten einzelne Bestimmungen unwirksam sein, bleibt die Wirksamkeit der übrigen unberührt.</p>
                    </article>
                </section>
            </ng-container>

            <ng-container *ngSwitchCase="'sign-order-terms'">
                <section class="page-hero section-pad compact">
                    <div class="container-xl centered-heading">
                        <span class="section-kicker">{{ 'SCN.LEGAL.KICKER' | translate }}</span>
                        <h1>{{ 'SCN.LEGAL.SIGN_ORDER_TERMS_TITLE' | translate }}</h1>
                    </div>
                </section>

                <section class="section-pad legal-section">
                    <article class="container-md legal-card">
                        <!--
                          HINWEIS: Die endgültige rechtliche Formulierung sollte vor dem Produktionsstart
                          von einem Rechtsanwalt geprüft werden.
                        -->
                        <h2>{{ 'SCN.LEGAL.SIGN_ORDER_TERMS_TITLE' | translate }}</h2>

                        <h3>1. Geltungsbereich</h3>
                        <p>Diese Bedingungen für physische QR-Schilderbestellungen („Schilderbestellbedingungen“) gelten für Bestellungen physischer QR-Schilder („Schilder“) über die Scanafy-Plattform. Die Bestellung ist ausschließlich für Unternehmen, Gewerbetreibende, Freiberufler und Einrichtungen vorgesehen („Kunde“). Verbraucher im Sinne des § 13 BGB sind von der Bestellung ausgeschlossen.</p>

                        <h3>2. Bestellung durch Unternehmen</h3>
                        <p>Die Bestellung physischer Schilder ist auf registrierte Scanafy-Nutzer mit einem aktiven Unternehmenskonto beschränkt. Die Nutzung der Scanafy-Plattform setzt die Annahme der Allgemeinen Geschäftsbedingungen (AGB) von Scanafy voraus.</p>

                        <h3>3. Berechtigung der bestellenden Person</h3>
                        <p>Die Person, die die Bestellung auslöst, bestätigt, dass sie zur Abgabe verbindlicher Bestellungen für das Unternehmen berechtigt ist. Scanafy führt in der Regel keine gesonderte Prüfung der Vertretungsberechtigung durch, behält sich dies jedoch in begründeten Einzelfällen vor. Die bestellende Person bleibt für die Richtigkeit der Bestellangaben verantwortlich.</p>

                        <h3>4. Vertragsgegenstand</h3>
                        <p>Gegenstand dieser Bedingungen ist die einmalige Herstellung und Lieferung individuell bedruckter physischer QR-Schilder auf Basis der jeweils vom Kunden in der Scanafy-Plattform hinterlegten und zur Bestellung freigegebenen Druckdaten. Die Schilder werden als separate physische Produkte und nicht als Teil des SaaS-Abonnements bereitgestellt.</p>

                        <h3>5. Vertragsschluss</h3>
                        <p>Die Darstellung von Schildern in der Scanafy-Plattform stellt kein rechtlich bindendes Angebot dar. Der Kunde gibt durch Abschluss des Bestellvorgangs und Bestätigung der Bestellzusammenfassung ein verbindliches Angebot zum Kauf der ausgewählten Schilder ab. Der Vertrag kommt erst durch eine gesonderte Bestellbestätigung von Scanafy (per E-Mail oder in der Plattform) zustande.</p>

                        <h3>6. Produktbeschreibung und individuelle Fertigung</h3>
                        <p>Das derzeit angebotene Produkt ist ein A5 Alu-Dibond-Schild (ca. 148 mm × 210 mm) mit wählbarer Bohroption und frei wählbarer Stückzahl. Alle Schilder werden individuell nach den vom Kunden bereitgestellten Druckdaten gefertigt. Produktabbildungen in der Plattform dienen der Veranschaulichung. Geringfügige Abweichungen zwischen Bildschirmdarstellung und physischem Druckergebnis (z.&nbsp;B. in Farbe oder Helligkeit) sind fertigungsbedingt möglich und stellen keinen Mangel dar, solange die Abweichung im Rahmen der drucktechnischen Toleranzen liegt. Die gewählte Bohroption und die gewählte Stückzahl werden mit der Bestellung verbindlich festgelegt.</p>

                        <h3>7. Maßgeblicher Bestell- und Drucksnapshot</h3>
                        <p>Für die Produktion ist ausschließlich der zum Zeitpunkt der Bestellung gespeicherte Bestell- und Drucksnapshot maßgeblich. Spätere Änderungen an den in der Scanafy-Plattform hinterlegten Objekt-, Unternehmens-, Kontakt-, Branding-, QR- oder Vorlagendaten wirken sich nicht automatisch auf bereits erteilte Bestellungen aus. Nachträgliche Änderungen am Auftrag bedürfen der Vereinbarung mit Scanafy.</p>

                        <h3>8. Verantwortung für Objekt-, Kontakt-, QR- und Branding-Daten</h3>
                        <p>Der Kunde ist allein verantwortlich für die Richtigkeit, Vollständigkeit und Rechtmäßigkeit aller für den Druck bereitgestellten Informationen, insbesondere Objektadressen, Kontaktdaten, Texte, QR-Code-Zieladressen, Logos, Bilder und sonstige Gestaltungselemente. Scanafy prüft die eingereichten Druckdaten nicht auf inhaltliche Richtigkeit, Vollständigkeit oder rechtliche Zulässigkeit.</p>

                        <h3>9. Rechte an Logos, Bildern, Texten und sonstigen Inhalten</h3>
                        <p>Der Kunde sichert zu, dass er über sämtliche erforderlichen Rechte (insbesondere Urheber-, Marken-, Design- und Persönlichkeitsrechte) an den von ihm für den Druck bereitgestellten Inhalten verfügt. Der Kunde stellt Scanafy von etwaigen Ansprüchen Dritter frei, die aus der Verletzung solcher Rechte durch die vom Kunden bereitgestellten Inhalte entstehen.</p>

                        <h3>10. Funktion und Grenzen des QR-Schilds</h3>
                        <p>Das Scanafy QR-Schild ermöglicht den Zugriff auf digitale Objekt- und Notfallinformationen über einen QR-Code. Das Schild dient der ergänzenden Informationsbereitstellung im Sinne der Scanafy SaaS-Plattform und ersetzt keine gesetzlich vorgeschriebenen Flucht-, Brandschutz-, Sicherheits- oder Notfallbeschilderungen. Das Schild ersetzt nicht die Kontaktaufnahme mit Rettungs- oder Notfalldiensten. Die Nutzung des Schilds liegt in der Verantwortung des Kunden und der jeweiligen Nutzer vor Ort.</p>

                        <h3>11. Preise und Mehrwertsteuer</h3>
                        <p>Alle in der Plattform angezeigten Preise für Schilder verstehen sich zuzüglich der gesetzlichen Umsatzsteuer. Maßgeblich ist der zum Zeitpunkt der Bestellung in der Bestellzusammenfassung angezeigte Gesamtpreis. Die in der Plattform angezeigten Zahlungsinformationen und Preisübersichten stellen keine förmliche Rechnung dar.</p>

                        <h3>12. Versandkosten</h3>
                        <p>Etwaige Versandkosten werden vor Abgabe der Bestellung in der Bestellzusammenfassung gesondert ausgewiesen.</p>

                        <h3>13. Zahlung</h3>
                        <p>Die Zahlung des vollständigen Kaufpreises (Schilderpreis zuzüglich Versandkosten und Umsatzsteuer) erfolgt per Banküberweisung anhand der in der Bestellzusammenfassung angezeigten Zahlungsanweisungen. Die Zahlung wird vor Produktionsbeginn fällig. Ein Anspruch auf Lieferung besteht erst nach vollständigem Zahlungseingang bei Scanafy.</p>

                        <h3>14. Produktionsbeginn</h3>
                        <p>Die Produktion der bestellten Schilder beginnt, sobald Scanafy den Zahlungseingang bestätigt hat. Soweit Produktions- oder Lieferzeiten angezeigt oder mitgeteilt werden, handelt es sich um unverbindliche Schätzungen, sofern nicht ausdrücklich etwas anderes vereinbart wurde.</p>

                        <h3>15. Änderungen und Stornierungen</h3>
                        <p>Da die Schilder individuell nach den Druckdaten des Kunden gefertigt werden, bedürfen Änderungen oder eine Stornierung der Bestellung nach Abgabe der Bestellung der Vereinbarung mit Scanafy. Nach Zahlungseingang oder Produktionsbeginn kann eine Stornierung oder Änderung ausgeschlossen sein oder zusätzliche Kosten verursachen. Bereits geleistete Zahlungen werden im Falle einer einvernehmlichen Stornierung nach Abzug etwaiger bereits entstandener Produktionskosten zurückerstattet.</p>

                        <h3>16. Lieferung</h3>
                        <p>Die Lieferung der Schilder erfolgt an die vom Kunden in der Bestellung angegebene Lieferadresse. Eine Lieferung ist derzeit nur innerhalb Deutschlands möglich. Liefertermine und Lieferfristen sind unverbindlich, soweit nicht ausdrücklich ein verbindlicher Liefertermin schriftlich vereinbart wurde. Die Lieferung erfolgt auf Gefahr des Kunden, soweit nicht ein Verbrauchsgüterkauf vorliegt.</p>

                        <h3>17. Prüfung der Lieferung und Schadensmeldung</h3>
                        <p>Der Kunde ist verpflichtet, die gelieferten Schilder unverzüglich nach Erhalt auf äußerlich erkennbare Transportschäden, Fehlmengen und offensichtliche Mängel zu prüfen. Solche Mängel sind Scanafy unverzüglich, spätestens innerhalb von fünf Werktagen nach Erhalt, in Textform (z.&nbsp;B. E-Mail) unter Beschreibung des Mangels anzuzeigen. Unterbleibt eine rechtzeitige Anzeige, gilt die Lieferung hinsichtlich offensichtlicher Mängel als genehmigt. Verdeckte Mängel sind Scanafy unverzüglich nach Entdeckung anzuzeigen.</p>

                        <h3>18. Montage</h3>
                        <p>Die Montage der Schilder ist nicht Bestandteil der Lieferung oder des Kaufpreises. Der Kunde ist für die Auswahl des Montageorts, die Einholung etwaiger erforderlicher Genehmigungen, die Auswahl geeigneten Befestigungsmaterials und die fachgerechte Montage selbst verantwortlich. Scanafy übernimmt keine Haftung für Schäden, die aus einer unsachgemäßen Montage oder der Wahl eines ungeeigneten Montageorts entstehen.</p>

                        <h3>19. Mängel und gesetzliche Rechte</h3>
                        <p>Es gelten die gesetzlichen Gewährleistungsvorschriften. Bei einem Mangel des gelieferten Schildes kann der Kunde zunächst Nacherfüllung in Form von Nachbesserung oder Ersatzlieferung (nach Wahl von Scanafy) verlangen. Schlägt die Nacherfüllung fehl oder ist sie unzumutbar, stehen dem Kunden die weiteren gesetzlichen Rechte (Rücktritt oder Minderung) zu. Die Verjährungsfrist für Gewährleistungsansprüche beträgt ein Jahr ab Lieferung, soweit gesetzlich keine längere Frist zwingend vorgeschrieben ist.</p>

                        <h3>20. Haftung</h3>
                        <p>Scanafy haftet unbeschränkt bei Vorsatz, grober Fahrlässigkeit, Verletzung von Leben, Körper oder Gesundheit sowie nach dem Produkthaftungsgesetz. Bei einfacher Fahrlässigkeit haftet Scanafy nur bei Verletzung wesentlicher Vertragspflichten (Kardinalpflichten); die Haftung ist in diesem Fall auf den vertragstypischen, vorhersehbaren Schaden beschränkt. Eine weitergehende Haftung von Scanafy ist ausgeschlossen. Die Haftung nach dem Produkthaftungsgesetz bleibt unberührt.</p>

                        <h3>21. Eigentumsvorbehalt</h3>
                        <p>Die gelieferten Schilder bleiben bis zur vollständigen Zahlung des Kaufpreises im Eigentum von Scanafy. Vor Eigentumsübergang ist der Kunde nicht berechtigt, die Schilder zu veräußern, zu verpfänden, zur Sicherheit zu übereignen oder Dritten entgeltlich oder unentgeltlich zu überlassen, es sei denn, Scanafy hat dem ausdrücklich zugestimmt.</p>

                        <h3>22. Datenschutz</h3>
                        <p>Informationen zur Verarbeitung personenbezogener Daten im Zusammenhang mit der Schilderbestellung finden Sie in der Datenschutzerklärung von Scanafy, insbesondere unter dem Abschnitt zur Verarbeitung von Daten für physische Schilderbestellungen.</p>

                        <h3>23. Verhältnis zu den allgemeinen Geschäftsbedingungen</h3>
                        <p>Für die Nutzung der Scanafy-Plattform gelten die <a [href]="getLegalRoute('terms')" (click)="navigateTop(getLegalRoute('terms'), $event)">Allgemeinen Geschäftsbedingungen (AGB)</a> von Scanafy. Für Bestellungen physischer Schilder gehen die vorliegenden Schilderbestellbedingungen den AGB vor, soweit sie speziellere Regelungen enthalten. Im Übrigen bleiben die AGB unberührt.</p>

                        <h3>24. Support und Kontakt</h3>
                        <p>Für Fragen zu Schilderbestellungen, Lieferstatus oder Reklamationen steht Scanafy per E-Mail an contact&#64;scanafy.de oder über die in der Plattform angegebenen Kontaktmöglichkeiten zur Verfügung.</p>

                        <h3>25. Schlussbestimmungen</h3>
                        <p>Es gilt deutsches Recht unter Ausschluss des UN-Kaufrechts (CISG). Gerichtsstand für alle Streitigkeiten aus und im Zusammenhang mit diesen Schilderbestellbedingungen ist Hamburg, soweit der Kunde Kaufmann, juristische Person des öffentlichen Rechts oder öffentlich-rechtliches Sondervermögen ist. Scanafy ist jedoch berechtigt, den Kunden auch an seinem allgemeinen Gerichtsstand zu verklagen. Sollten einzelne Bestimmungen dieser Schilderbestellbedingungen ganz oder teilweise unwirksam sein oder werden, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.</p>
                    </article>
                </section>
            </ng-container>
        </ng-container>
    </main>

    <footer class="site-footer">
        <div class="container-xl footer-grid">
            <div>
                <a
                        class="brand footer-brand"
                        [href]="navPath(navItems[0])"
                        (click)="navigateTop(navPath(navItems[0]), $event)"
                >
                    <img
                            src="assets/scanafy-logo-44.webp"
                            srcset="assets/scanafy-logo-44.webp 1x, assets/scanafy-logo-88.webp 2x"
                            alt="Scanafy Logo"
                            width="44"
                            height="44"
                            loading="lazy"
                            decoding="async"
                    />
                    <span>Scanafy</span>
                </a>
                <p>{{ 'SCN.FOOTER.TEXT' | translate }}</p>
            </div>
            <div>
                <strong>{{ 'SCN.FOOTER.PRODUCT' | translate }}</strong>
                <a
                        [href]="navPath(navItems[1])"
                        (click)="navigateTop(navPath(navItems[1]), $event)"
                >
                    {{ 'SCN.NAV.PRODUCT' | translate }}
                </a>
                <a
                        [href]="navPath(navItems[2])"
                        (click)="navigateTop(navPath(navItems[2]), $event)"
                >
                    {{ 'SCN.NAV.PRICING' | translate }}
                </a>
                <a href="/docs" target="_blank" rel="noopener noreferrer">Docs</a>
            </div>
            <div>
                <strong>{{ 'SCN.FOOTER.COMPANY' | translate }}</strong>
                <a
                        [href]="navPath(navItems[3])"
                        (click)="navigateTop(navPath(navItems[3]), $event)"
                >
                    {{ 'SCN.NAV.CUSTOMERS' | translate }}
                </a>
                <a
                        [href]="navPath(navItems[5])"
                        (click)="navigateTop(navPath(navItems[5]), $event)"
                >
                    {{ 'SCN.NAV.CONTACT' | translate }}
                </a>
                <a
                        [href]="getLegalRoute('imprint')"
                        (click)="navigateTop(getLegalRoute('imprint'), $event)"
                >
                    {{ 'SCN.LEGAL.IMPRINT_LINK' | translate }}
                </a>
                <a
                        [href]="getLegalRoute('privacy')"
                        (click)="navigateTop(getLegalRoute('privacy'), $event)"
                >
                    {{ 'SCN.LEGAL.PRIVACY_LINK' | translate }}
                </a>
                <a
                        [href]="getLegalRoute('terms')"
                        (click)="navigateTop(getLegalRoute('terms'), $event)"
                >
                    {{ 'SCN.LEGAL.TERMS_LINK' | translate }}
                </a>
                <a
                        [href]="getLegalRoute('signOrderTerms')"
                        (click)="navigateTop(getLegalRoute('signOrderTerms'), $event)"
                >
                    {{ 'SCN.LEGAL.SIGN_ORDER_TERMS_LINK' | translate }}
                </a>
            </div>
            <div>
                <strong>{{ 'SCN.FOOTER.CONTACT' | translate }}</strong>
                <a href="mailto:contact@scanafy.de">contact&#64;scanafy.de</a>
                <a href="tel:+4915125019782">0151 25019782</a>
                <strong class="footer-social-title">{{ 'COMPANY_LANDING_PAGE.FOLLOW_US' | translate }}</strong>
                <div class="social-links mt-2 d-flex flex-wrap gap-2 align-items-center">
                    <a
                            class="social-icon-btn"
                            href="https://www.linkedin.com/company/scanafy-de/"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="LinkedIn"
                            title="LinkedIn"
                    >
                        <i class="bi bi-linkedin"></i>
                    </a>

                    <a
                            class="social-icon-btn"
                            href="https://wa.me/4915125019782"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="WhatsApp"
                            title="WhatsApp"
                    >
                        <i class="bi bi-whatsapp"></i>
                    </a>

                    <a
                            class="social-icon-btn"
                            href="https://www.facebook.com/OfficialScanafy/"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Facebook"
                            title="Facebook"
                    >
                        <i class="bi bi-facebook"></i>
                    </a>

                    <a
                            class="social-icon-btn"
                            href="https://www.instagram.com/scanafy/"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Instagram"
                            title="Instagram"
                    >
                        <i class="bi bi-instagram"></i>
                    </a>
                </div>
            </div>
        </div>
        <div class="container-xl footer-bottom">
            <span>© Scanafy 2026. All rights reserved.</span>
            <span>{{ 'SCN.FOOTER.TAGLINE' | translate }}</span>
        </div>
    </footer>

    <ng-template #bookingDemoModal>
        <div class="booking-modal-content">
            <iframe
                    [src]="bookingDemoUrl"
                    [attr.title]="'SCN.BOOKING.IFRAME_TITLE' | translate"
                    class="booking-iframe"
                    loading="lazy"
                    scrolling="yes"
                    referrerpolicy="no-referrer-when-downgrade"
            ></iframe>
            <div class="booking-fallback">
                {{ 'SCN.BOOKING.FALLBACK_TEXT' | translate }}
                <a [href]="rawBookingDemoUrl" target="_blank" rel="noopener noreferrer">
                    {{ 'SCN.BOOKING.FALLBACK_LINK' | translate }}
                </a>
            </div>
        </div>
    </ng-template>

    <ng-template #bookingMobileFallbackModal>
        <div class="booking-mobile-fallback">
            <div class="booking-mobile-icon"><i class="bi bi-calendar-check"></i></div>
            <h3>{{ 'SCN.BOOKING.MOBILE_TITLE' | translate }}</h3>
            <p>{{ 'SCN.BOOKING.MOBILE_TEXT' | translate }}</p>
            <a [href]="rawBookingDemoUrl" target="_blank" rel="noopener noreferrer" class="btn btn-primary">
                {{ 'SCN.BOOKING.MOBILE_BUTTON' | translate }}
            </a>
            <button type="button" class="btn btn-link" (click)="closeAllModals()">
                {{ 'SCN.BOOKING.MOBILE_CANCEL' | translate }}
            </button>
        </div>
    </ng-template>

    <button
            type="button"
            class="scn-back-top-fixed"
            (click)="scrollToTop()"
            aria-label="Back to top"
            title="Back to top"
    >
        <span aria-hidden="true">↑</span>
    </button>
</div>
